import React from 'react';
import { Link } from 'react-router-dom';

const DownloadIcon = () => (
  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
  </svg>
);

const ExternalLinkIcon = () => (
  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
  </svg>
);

const DocumentIcon = () => (
  <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
  </svg>
);

const DesignerIcon = () => (
  <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909M3.75 21h16.5A2.25 2.25 0 0022.5 18.75V5.25A2.25 2.25 0 0020.25 3H3.75A2.25 2.25 0 001.5 5.25v13.5A2.25 2.25 0 003.75 21z" />
  </svg>
);

export const MarketingResourcesPage: React.FC = () => {
  const brochurePdfUrl = '/documents/Keder_Brochure.pdf';
  const vtrackComparisonPdfUrl = '/documents/VTrack_Comparison.pdf';

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold text-white">Marketing Resources</h1>
        <p className="text-gray-400 mt-1">
          Downloadable marketing materials for Keder Screens dealers
        </p>
      </div>

      {/* Resources Grid */}
      <div className="grid gap-4 md:grid-cols-2">
        {/* Brochure Card */}
        <div className="card p-6 hover:border-keder-yellow transition-colors group">
          <div className="flex items-start gap-4">
            <div className="text-gray-400 group-hover:text-keder-yellow transition-colors">
              <DocumentIcon />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-white font-medium group-hover:text-keder-yellow transition-colors">
                Keder Screens Brochure
              </h3>
              <p className="text-gray-400 text-sm mt-1">Product brochure for customer handouts</p>
              <div className="flex flex-wrap gap-2 mt-4">
                <a
                  href={brochurePdfUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-secondary text-sm flex items-center gap-2"
                >
                  <ExternalLinkIcon />
                  <span>View PDF</span>
                </a>
                <a
                  href={brochurePdfUrl}
                  download="Keder_Brochure.pdf"
                  className="btn-secondary text-sm flex items-center gap-2"
                >
                  <DownloadIcon />
                  <span>Download</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* V-Track Comparison Card */}
        <div className="card p-6 hover:border-keder-yellow transition-colors group">
          <div className="flex items-start gap-4">
            <div className="text-gray-400 group-hover:text-keder-yellow transition-colors">
              <DocumentIcon />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-white font-medium group-hover:text-keder-yellow transition-colors">
                V-Track Comparison Guide
              </h3>
              <p className="text-gray-400 text-sm mt-1">Compare V-Track to zipper and magnet track systems</p>
              <div className="flex flex-wrap gap-2 mt-4">
                <a
                  href={vtrackComparisonPdfUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-secondary text-sm flex items-center gap-2"
                >
                  <ExternalLinkIcon />
                  <span>View PDF</span>
                </a>
                <a
                  href={vtrackComparisonPdfUrl}
                  download="VTrack_Comparison.pdf"
                  className="btn-secondary text-sm flex items-center gap-2"
                >
                  <DownloadIcon />
                  <span>Download</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Screen Designer Card */}
        <div className="card p-6 hover:border-keder-yellow transition-colors group">
          <div className="flex items-start gap-4">
            <div className="text-gray-400 group-hover:text-keder-yellow transition-colors">
              <DesignerIcon />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-white font-medium group-hover:text-keder-yellow transition-colors">
                Screen Designer
              </h3>
              <p className="text-gray-400 text-sm mt-1">Upload a patio photo and visualize how screens will look with different fabrics and frames</p>
              <div className="flex flex-wrap gap-2 mt-4">
                <Link
                  to="/designer"
                  className="btn-primary text-sm flex items-center gap-2"
                >
                  <DesignerIcon />
                  <span>Open Screen Designer</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketingResourcesPage;
